import React, { useEffect, useMemo } from 'react'
import { RouteProps, useLocation, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import PageTemplate, { PageTemplateProps } from '../../templates/Page'
import { useHeader } from '../../relay/Header/useHeader'
import { useFooter } from '../../relay/Footer/useFooter'
import { actions, selectors } from '../../redux'
import { ActionButtonProps } from '../../components/ActionButton'
import { ActionButtonVariant, ActionButtonLook } from '../../components/ActionButton/styled'
import { routesPath } from '../../router'
import { MediaProps } from '../../components/MediaComponent'

// Enum pour la position du média
export enum MediaPosition {
  Bottom = 'BOTTOM',
  Top = 'TOP',
}

const Page: React.FC<RouteProps> = () => {
  const header = useHeader()
  const footer = useFooter()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const page = useSelector(selectors.page.getPageBySlug)
  const { slug } = useParams()
  const navigate = useNavigate()
  const location = useLocation()

  console.log(page)

  useEffect(() => {
    slug && dispatch(actions.page.getPageBySlugRequest({ slug: slug }))
  }, [dispatch, slug])

  useEffect(() => {
    if (page.complete && page.errors) {
      navigate('/')
    }
  }, [page, navigate, slug])

  const headerButton: ActionButtonProps = useMemo(() => {
    return {
      text: t('userDeclarations.banner.headerButton.text'),
      variant: ActionButtonVariant.white,
      look: ActionButtonLook.outlined,
      iconProps: {
        icon: 'arrowLeft',
      },
      iconPosition: 'left',
      onClick: () => {
        navigate(-1)
      },
    }
  }, [navigate, t])

  const media = useMemo<MediaProps | undefined>(() => {
    if (page.data?.video) {
      return {
        mediaType: 'video',
        src: `${page.data.video}`,
      }
    } else if (page.data?.image) {
      return {
        mediaType: 'image',
        src: `${page.data.image}`,
        alt: page.data.image_alt || 'Media',
      }
    }
    return undefined
  }, [page.data])

  const isMediaAtTop = useMemo(() => {
    return page.data?.media_position === MediaPosition.Top
  }, [page.data?.media_position])

  const templateProps: PageTemplateProps = useMemo(
    () => ({
      layoutProps: {
        header,
        footer,
      },
      banner: {
        title: page.data?.name ?? '',
        headerButton: location.pathname === routesPath.faq ? headerButton : undefined,
      },
      html: {
        text: page.data?.content,
      },
      media: media,
      isMediaAtTop: isMediaAtTop,
    }),
    [
      footer,
      header,
      headerButton,
      location.pathname,
      media,
      page.data?.content,
      page.data?.name,
      isMediaAtTop,
    ]
  )

  return <PageTemplate {...templateProps} />
}

export default Page
